import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import stockLocationKeys from '@/api/queries/stockLocations/keyFactory';
import { graphql } from '@/gql';
import {
  UpdateStockLocationMutation as TUpdateStockLocationMutation,
  UpdateStockLocationInput,
} from '@/gql/graphql';

const UpdateStockLocationMutation = graphql(`
  mutation UpdateStockLocation($input: UpdateStockLocationInput!) {
    updateStockLocation(input: $input) {
      id
      name
    }
  }
`);

const useUpdateStockLocation = (
  options?: UseMutationOptions<
    TUpdateStockLocationMutation,
    unknown,
    UpdateStockLocationInput
  >
) => {
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = options ?? {};

  return useMutation({
    mutationFn: (input) =>
      gqlClient.request(UpdateStockLocationMutation, { input }),
    onSuccess: (data, variables, context) => {
      void queryClient.invalidateQueries({ queryKey: stockLocationKeys.all });
      onSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
};

export default useUpdateStockLocation;
